import axios from 'axios';
import { apiBaseUrl } from '@/apis/appconst';

// ================================
// AUTHENTICATION APIS (FormData-based)
// ================================

// 🔹 Register
export async function registerNow(fname, lname, email, password, mobile) {
  try {
    const fd = new FormData();
    fd.append('fname', fname);
    fd.append('lname', lname);
    fd.append('email', email);
    fd.append('password', password);
    fd.append('mobile', mobile);

    const response = await axios.post(`${apiBaseUrl}authapis/register_now`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    return response.data;
  } catch (error) {
    return { status: false, type: 'danger', success: 'Request Failed' };
  }
}

// 🔹 Login
export async function loginNow(email, password) {
  try {
    const fd = new FormData();
    fd.append('email', email);
    fd.append('password', password);

    const response = await axios.post(`${apiBaseUrl}authapis/login_now`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    return response.data;
  } catch (error) {
    return { status: false, type: 'danger', success: 'Request Failed' };
  }
}

// 🔹 Logout
export async function logoutNow(user_id) {
  try {
    const response = await axios.get(`${apiBaseUrl}authapis/logout_now`, {
      params: { user_id },
    });
    return response.data;
  } catch (error) {
    return { status: false, type: 'danger', success: 'Request Failed' };
  }
}

// 🔹 Forgot Password
export async function forgotNow(email) {
  try {
    const fd = new FormData();
    fd.append('email', email);

    const response = await axios.post(`${apiBaseUrl}authapis/forgot_now`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    return response.data;
  } catch (error) {
    return { status: false, type: 'danger', success: 'Request Failed' };
  }
}

// 🔹 Verify Email
export async function verifyEmail(token) {
  try {
    const response = await axios.get(`${apiBaseUrl}authapis/ver_email`, {
      params: { token },
    });
    return response.data;
  } catch (error) {
    return { status: false, type: 'danger', success: 'Invalid or expired verification link' };
  }
}

// 🔹 Change Password
export async function changePassNow(user_id, old_pass, new_pass) {
  try {
    const fd = new FormData();
    fd.append('user_id', user_id);
    fd.append('old_pass', old_pass);
    fd.append('new_pass', new_pass);

    const response = await axios.post(`${apiBaseUrl}authapis/change_pass_now`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    return response.data;
  } catch (error) {
    return { status: false, type: 'danger', success: 'Password update failed' };
  }
}

export const getUserById = async (user_id) => {
  try {
    const fd = new FormData();
    fd.append("user_id", user_id);

    const response = await axios.post(`${apiBaseUrl}authapis/get_user_by_id`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    if (response.data && response.data.status) {
      return response.data.data; // returns user object
    } else {
      console.error("API Error:", response.data);
      return null;
    }
  } catch (error) {
    console.error("Request Failed:", error);
    return null;
  }
};



export async function updateUserPlan(user_id, plan_id) {
  try {
    const fd = new FormData();
    fd.append("user_id", user_id);
    fd.append("plan_id", plan_id);

    const response = await axios.post(`${apiBaseUrl}authapis/update_user_plan`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("updateUserPlan error:", error);
    return { status: false, type: "danger", success: "Failed to update plan" };
  }
}

// ================================
// 1️⃣ Get Notifications (list)
// ================================
export async function getNotifications(noti_user1, page_no) {
  try {
    const form = new FormData();
    form.append("noti_user1", noti_user1);
    form.append("page_no", page_no);

    const res = await axios.post(`${apiBaseUrl}authapis/get_notifications`, form);
    return res.data;
  } catch (err) {
    return { status: false, success: "Network error!" };
  }
}

// ================================
// 2️⃣ Delete Notification
// ================================
export async function deleteNotification(notification_id) {
  try {
    const form = new FormData();
    form.append("notification_id", notification_id);

    const res = await axios.post(`${apiBaseUrl}authapis/delete_notification`, form);
    return res.data;
  } catch (err) {
    return { status: false, success: "Network error!" };
  }
}

export async function getUnreadNotiCount(noti_user1) {
  try {
    const fd = new FormData();
    fd.append("noti_user1", noti_user1);

    const res = await axios.post(
      `${apiBaseUrl}authapis/get_unread_notification_count`,
      fd
    );

    return res.data;
  } catch (err) {
    return { status: false, count: 0 };
  }
}

export const loadWeb = async () => {
  try {
    const fd = new FormData();

    const response = await axios.get(`${apiBaseUrl}authapis/load_web`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });


   return response.data;
  } catch (error) {
    console.error("Request Failed:", error);
    return null;
  }
};
